import { googleAnalyticsService } from '../../../service/google-analytics-service'
import { messageService } from '../../../service/message-service'
import { metaPixelService } from '../../../service/meta-pixel-service'
import { errorUtil } from '../../../util/auth-error-util'
import { EventBusActionType, EventBusEntityType, EventBusMessage, eventBusUtil } from '../../../util/auth-event-bus-util'
import { cacheUtil } from '../../../util/cache-util'
import { logger } from '../../../util/logger'
import { Subscription } from 'rxjs'

export class EventBusController {
  protected _subscriptions: Subscription[] = []

  protected _subscribe(
    params: { entities?: EventBusEntityType[]; actions?: EventBusActionType[] },
    cb: (eventMessage: EventBusMessage) => Promise<void>,
  ): void {
    this._subscriptions.push(eventBusUtil().subscribe(params, cb))
  }

  public unsubscribe(): void {
    this._subscriptions.forEach((s) => s.unsubscribe())
    this._subscriptions = []
  }

  public register(): void {
    this._userCreated()
    this._registrationCompleted()
    this._emailVerified()
    this._subscribeToEmailNotifications()
  }

  protected _userCreated(): void {
    this._subscribe(
      {
        entities: [EventBusEntityType.USER],
        actions: [EventBusActionType.CREATE],
      },
      async (eventMessage: EventBusMessage) => {
        try {
          googleAnalyticsService.sendUserCreated({ message: eventMessage })
        } catch (error) {
          errorUtil.logError(error)
        }
        try {
          metaPixelService.sendUserCreated({ message: eventMessage })
        } catch (error) {
          errorUtil.logError(error)
        }
        logger.debug('User created event')
      },
    )
  }

  protected _registrationCompleted(): void {
    this._subscribe(
      {
        entities: [EventBusEntityType.REGISTRATION],
        actions: [EventBusActionType.CREATE],
      },
      async (eventMessage: EventBusMessage) => {
        try {
          googleAnalyticsService.sendRegistrationCompleted({ message: eventMessage })
        } catch (error) {
          errorUtil.logError(error)
        }
        try {
          metaPixelService.sendRegistrationCompleted({ message: eventMessage })
        } catch (error) {
          errorUtil.logError(error)
        }
        logger.debug('Registration completed event')
      },
    )
  }

  protected _emailVerified(): void {
    this._subscribe(
      {
        entities: [EventBusEntityType.EMAIL_VERIFIED],
        actions: [EventBusActionType.CREATE],
      },
      async (_eventMessage: EventBusMessage) => {
        // TODO: Re-enable when message service method is available
        // try {
        //   messageService.sendEmailVerified({ message: eventMessage })
        // } catch (error) {
        //   errorUtil.logError(error)
        // }
        logger.debug('Email verified event')
      },
    )
  }

  public _subscribeToEmailNotifications(): void {
    this._subscribe(
      {
        entities: [EventBusEntityType.MEMBERSHIP],
        actions: [EventBusActionType.CREATE],
      },
      async (_: EventBusMessage) => {
        try {
          messageService.subscribeToEmailNotifications()
        } catch (error) {
          errorUtil.logError(error)
        }
      },
    )
  }
}

export const eventBusController = cacheUtil.singleton((): EventBusController => new EventBusController())
